import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';

import { sindyTableData } from 'lib/api/media';
import { paramConverter } from 'modules/common';
import { makeHeadData } from 'lib/commonLib';

import BasicTable from 'components/molecules/MbBasicTable';
import SnackbarWrap from 'components/organisms/Snackbar/SnackbarWrap';

const useStyles = makeStyles((theme) => ({
  title: {
    flex: '0 0 auto',
    marginBottom: 10,
  },
}));

const MediaSindyTable = ({ params }) => {
  const { t } = useTranslation();
  const classes = useStyles();

  const tableHead = {
    headList: [
      {
        id: 'AMT_TYPE',
        label: t('구분'),
        orderFlag: false,
        type: 'string',
        format: '@',
      },
      {
        id: 'ADVRTS_AMT',
        label: t('매출'),
        orderFlag: false,
        type: 'number',
        format: '#,##0',
      },
    ],
    sort: 'desc',
    order: 'STATS_DTTM',
  };
  const initTableList = [];
  const [tableList, setTableList] = useState(initTableList);
  const initLoading = {
    table: true,
  };
  const [loading, setLoading] = useState(initLoading);

  const initSnackbar = {
    open: false,
    variant: '',
    message: '',
  };
  const [snackbar, setSnackbar] = useState(initSnackbar);

  useEffect(() => {
    getData(); // eslint-disable-next-line
  }, [params]);

  const getData = () => {
    setLoading(initLoading);
    setTableList(initTableList);
    sindyTableData({ ...paramConverter(params) })
      .then((response) => {
        const { data } = response.data;
        setTableList(data);
      })
      .catch((error) => {
        setSnackbar({
          ...snackbar,
          open: true,
          variant: 'error',
          message: error,
        });
      })
      .finally(() => {
        setLoading({
          ...loading,
          table: false,
        });
      });
  };

  /**
   * 스낵바 닫는 함수
   * 연속 클릭이 들어왔을 때는 기존 스낵바를 유지
   * @param event
   * @param reason
   */
  const handleSnackBarClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setSnackbar({
      ...snackbar,
      open: false,
      message: '',
    });
  };

  return (
    <>
      <div className={classes.title}>
        <Typography variant="h6">{t('신디매출')}</Typography>
      </div>
      <BasicTable
        sort={tableHead.sort}
        order={tableHead.order}
        list={tableList}
        headCells={makeHeadData(tableHead.headList)}
        loading={loading.table}
      />
      <SnackbarWrap
        open={snackbar.open}
        variant={snackbar.variant}
        message={snackbar.message}
        onClose={handleSnackBarClose}
      />
    </>
  );
};

export default MediaSindyTable;
